import React, { useRef } from 'react'
import { Select as AntdSelect } from 'antd'

/**
 *
 * @description Select ini untuk memperbaiki pemakaian select dengan popover yang akan close popover ketika
 * click selectnya
 * @param props {import('antd').SelectProps & {divProps: React.HTMLAttributes<HTMLDivElement>}}
 * @returns {Element}
 * @constructor
 */
const Select = ({ divProps = {}, ...props }) => {
  const containerRef = useRef()

  return (
    <div ref={containerRef} {...divProps}>
      <AntdSelect getPopupContainer={() => containerRef.current} {...props} />
    </div>
  )
}

export default Select
